import { SvgIcon, SvgIconProps } from '@mui/material';

export function PersonPinIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="person_pin" clipPath="url(#clip0_1169_35302)">
          <path
            id="Vector"
            d="M25.3333 2.66895H6.66667C5.18667 2.66895 4 3.86895 4 5.33561V24.0023C4 25.4689 5.2 26.6689 6.66667 26.6689H12L15.0533 29.7223C15.5733 30.2423 16.4133 30.2423 16.9333 29.7223L20 26.6689H25.3333C26.8 26.6689 28 25.4689 28 24.0023V5.33561C28 3.86895 26.8 2.66895 25.3333 2.66895ZM16 7.06895C17.9867 7.06895 19.6 8.68228 19.6 10.6689C19.6 12.6556 17.9867 14.2689 16 14.2689C14.0133 14.2689 12.4 12.6556 12.4 10.6689C12.4 8.68228 14.0133 7.06895 16 7.06895ZM24 21.3356H8V20.1356C8 17.4689 13.3333 16.0023 16 16.0023C18.6667 16.0023 24 17.4689 24 20.1356V21.3356Z"
            fill="currentColor"
          />
        </g>
        <defs>
          <clipPath id="clip0_1169_35302">
            <rect
              width="32"
              height="32"
              fill="transparent"
              transform="translate(0 0.00195312)"
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
}
